import React, { Component } from 'react';
import '../myutils';
import restClient from '../restClient';
import { CREATE } from 'react-admin';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction, translate } from 'react-admin';
import { push as pushAction } from 'react-router-redux';
import ActionNoteAdd from '@material-ui/icons/NoteAdd';


class CreateTemplateButton extends Component {

    handleClick = () => {
        const { push, showNotification } = this.props;
        restClient(CREATE, 'CreateTemplate', { })
            .then((response) => {

                showNotification('Comment approved');
                push('/IVR?');
                push('/Templates?new');
            })
            .catch((e) => {
                console.error(e);
                showNotification('Error: comment not approved', 'warning')
            });
    }

    render() {
        const { translate } = this.props;
        return <Button primary label={translate(`resources.templates.new_template`)} onClick={this.handleClick} ><ActionNoteAdd color="primary"/><label style={{ color: 'darkblue', cursor:"pointer" }}>{translate(`resources.templates.new_template`)}</label> </Button>;
    }
}

CreateTemplateButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(translate(CreateTemplateButton));